import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import styles from './PieChart.styles';
import { ResponsivePie } from '@nivo/pie';
import { BoxLegendSvg } from '@nivo/legends';
import { cloneDeep } from 'lodash';

const PieLegends = ({ height, legends, width, ...rest }) => {
  console.log('PieLegends', height, legends, width, rest);

  // return null;
  return (
    <React.Fragment>
      {(Array.isArray(legends) ? legends : [legends]).map(legend => (
        <BoxLegendSvg
          key={JSON.stringify(legend?.dataWithArc?.map(({ id }) => id))}
          {...legend}
          containerHeight={height}
          containerWidth={width}
        />
      ))}
    </React.Fragment>
  );
};

const getCenteredMetric = kpi => ({ dataWithArc, centerX, centerY, ...rest }) => {
  return (
    <text
      x={centerX}
      y={centerY}
      textAnchor="middle"
      dominantBaseline="central"
      style={{
        fontSize: '3vw',
        fontWeight: 600,
        fill: kpi.primaryMetricLabelColor,
      }}
    >
      {kpi.primaryMetricLabel}
    </text>
  );
};

const PieChart = props => {
  const { classes, data, chartProps, onClick, ...rest } = props;

  const chartOptions = useMemo(
    () => ({
      startAngle: 120,
      endAngle: -120,
      arcLabelsSkipAngle: 10,
      enableArcLinkLabels: false,
      arcLabelsTextColor: 'white',
      padAngle: 2,
      innerRadius: 0.5,
      cornerRadius: 3,
      colors: { datum: 'data.color' },
      borderWidth: 2,
      animate: true,
      motionStiffness: 90,
      motionDamping: 15,

      legends: [
        {
          data: cloneDeep(data).reverse(), // reverse the order of the legend
          anchor: 'bottom',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: 15,
          itemsSpacing: 0,
          itemWidth: 60,
          itemHeight: 18,

          itemTextColor: '#999',
          itemDirection: 'top-to-bottom',
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],

          onClick,
        },
      ],

      // SPACING
      margin: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 60,
      },

      layers: [
        //
        'arcs',
        'arcLabels',
        'arcLinkLabels',
        'legends',
        getCenteredMetric(props),
        // PieLegends,
      ],

      theme: {
        labels: {
          text: {
            fontSize: 16,
            fontWeight: 600,
          },
        },
      },
    }),
    [data],
  );

  return (
    <div
      style={{
        height: 'calc(30vh)',
      }}
    >
      <ResponsivePie
        //
        {...chartOptions}
        {...chartProps}
        {...rest}
        onClick={onClick}
        data={data}
      />
    </div>
  );
};

PieChart.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(PieChart);
